<app-modal
  *ngIf="data as modalData"
  [title]="modalTitle"
  [size]="'xl'"
  [confirmLabel]="selectedEntry() ? 'Zapisz zmiany' : 'Dodaj wpis'"
  [cancelLabel]="'Zamknij'"
  [showCancel]="true"
  [showConfirm]="true"
  [isConfirmDisabled]="!canSaveCurrentSelection()"
  [onConfirmAction]="onSave.bind(this)"
>
  <div class="tracker-modal-grid">
    <section class="tracker-modal-main">
      <div class="tracker-modal-hero">
        <div>
          <p class="tracker-modal-eyebrow">Dzień w trackerze</p>
          <h3>{{ (modalData.dateIso + 'T00:00:00') | date: 'dd.MM.yyyy' }}</h3>
          <p class="tracker-modal-subtitle">Wpisy dnia i szybka edycja</p>
        </div>

        <div class="tracker-modal-badges">
          <p-badge [value]="dayEntries().length + ' wpisów'" severity="info"></p-badge>
          <p-badge [value]="formatDuration(dayTotalDuration())" severity="success"></p-badge>
          <p-badge
            *ngIf="dayTotalEarnings() > 0"
            [value]="'Wynagrodzenie ' + formatMoney(dayTotalEarnings())"
            severity="success"
          ></p-badge>
          <p-badge
            *ngIf="selectedEntry()?.editableByCurrentUser === false"
            value="Tylko do odczytu"
            severity="secondary"
          ></p-badge>
        </div>
      </div>

      <form [formGroup]="timeEntryForm" class="tracker-modal-form">
        <div class="tracker-modal-card">
          <div class="tracker-modal-card-head">
            <div>
              <p class="tracker-modal-card-kicker">Formularz</p>
              <h4>{{ selectedEntry() ? 'Edycja wpisu' : 'Nowy wpis' }}</h4>
            </div>

            <p-button label="Nowy wpis" severity="secondary" outlined (onClick)="startNewEntry()"></p-button>
          </div>

          <p-divider></p-divider>

          <div class="tracker-modal-fields">
            <div class="tracker-modal-field">
              <label for="workItemId">Work item</label>
              <p-select
                inputId="workItemId"
                formControlName="workItemId"
                [options]="workItemOptions()"
                optionLabel="name"
                optionValue="id"
                placeholder="Wybierz work item"
                appendTo="body"
                styleClass="w-full"
              >
                <ng-template let-item pTemplate="item">
                  <div class="tracker-modal-option">
                    <span>{{ item.name || 'Bez nazwy' }}</span>
                    <small>{{ item.clientName || 'Bez klienta' }}</small>
                  </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                  <span>{{ item?.name || 'Bez nazwy' }}</span>
                </ng-template>
              </p-select>
            </div>

            <div class="tracker-modal-field">
              <label for="dateIso">Dzień wpisu</label>
              <input
                id="dateIso"
                type="date"
                pInputText
                formControlName="dateIso"
                class="w-full"
              />
              <small class="tracker-modal-help">
                Możesz przenieść wpis na inny dzień bez zmiany godzin.
              </small>
            </div>

            <div class="tracker-modal-row tracker-modal-row--three">
              <div class="tracker-modal-field">
                <label for="start">Start</label>
                <input
                  id="start"
                  pInputText
                  formControlName="start"
                  placeholder="08:00"
                  inputmode="numeric"
                  class="w-full"
                  (click)="onTimeClick('start', $event)"
                  (blur)="onChangeTimeEntry('start')"
                />
              </div>

              <div class="tracker-modal-field">
                <label for="end">Koniec</label>
                <p-overlaybadge *ngIf="isOvernight()" value="+1" severity="info">
                  <input
                    id="end"
                    pInputText
                    formControlName="end"
                    placeholder="16:00"
                    inputmode="numeric"
                    class="w-full"
                    (click)="onTimeClick('end', $event)"
                    (blur)="onChangeTimeEntry('end')"
                  />
                </p-overlaybadge>
                <input
                  *ngIf="!isOvernight()"
                  id="end"
                  pInputText
                  formControlName="end"
                  placeholder="16:00"
                  inputmode="numeric"
                  class="w-full"
                  (click)="onTimeClick('end', $event)"
                  (blur)="onChangeTimeEntry('end')"
                />
              </div>

              <div class="tracker-modal-field">
                <label>Czas</label>
                <input
                  pInputText
                  [value]="formatDuration(timeEntryForm.controls.duration.value)"
                  readonly
                  class="w-full tracker-modal-readonly"
                />
              </div>
            </div>

            <div class="tracker-modal-threshold" *ngIf="showRevenueField">
              <label for="revenueAmount">{{ revenueFieldLabel }}</label>
              <div class="tracker-modal-threshold-control">
                <p-inputNumber
                  inputId="revenueAmount"
                  formControlName="revenueAmount"
                  mode="currency"
                  currency="PLN"
                  locale="pl-PL"
                  [min]="0"
                  [step]="0.01"
                  placeholder="0,00 zł"
                  styleClass="w-full"
                ></p-inputNumber>
                <small class="tracker-modal-help">
                  Dla rozliczenia progowego wpisz kwotę bazową.
                </small>
              </div>
            </div>

            <div *ngIf="displayedEntryEarnings() != null" class="tracker-modal-summary">
              <span>Wynagrodzenie użytkownika</span>
              <strong>{{ formatMoney(displayedEntryEarnings()) }}</strong>
            </div>

            <div class="tracker-modal-field">
              <label for="billable">Płatny</label>
              <p-toggleswitch id="billable" formControlName="billable"></p-toggleswitch>
            </div>

            <div class="tracker-modal-field">
              <label for="description">Opis</label>
              <textarea
                id="description"
                pTextarea
                rows="4"
                maxlength="300"
                formControlName="description"
                placeholder="Opcjonalny opis wpisu"
                class="w-full"
              ></textarea>
            </div>

            <div *ngIf="selectedEntry()?.createdByUserName || selectedEntry()?.createdDate" class="tracker-modal-meta">
              <div>
                <strong>Utworzono przez:</strong>
                <span>{{ selectedEntry()?.createdByUserName || 'nieznany' }}</span>
              </div>
              <span *ngIf="selectedEntry()?.createdDate">
                {{ selectedEntry()?.createdDate | date: 'dd.MM.yyyy, HH:mm' }}
              </span>
            </div>

            <div *ngIf="isReadOnlySelection()" class="tracker-modal-readonly-note">
              Ten wpis został dodany przez właściciela i jest tylko do odczytu.
            </div>

            <div class="tracker-modal-actions" *ngIf="selectedEntry()?.editableByCurrentUser !== false">
              <p-button
                *ngIf="selectedEntry()"
                label="Usuń wpis"
                severity="danger"
                outlined
                [disabled]="saving()"
                (onClick)="onDeleteSelectedEntry()"
              ></p-button>
            </div>
          </div>
        </div>
      </form>
    </section>

    <section class="tracker-modal-side">
      <div class="tracker-modal-card">
        <div class="tracker-modal-card-head">
          <div>
            <p class="tracker-modal-card-kicker">Wpisy z dnia</p>
            <h4>{{ dayEntries().length }} wpisów</h4>
          </div>
          <p-badge
            *ngIf="dayTotalEarnings() > 0"
            [value]="'Wynagrodzenie ' + formatMoney(dayTotalEarnings())"
            severity="success"
          ></p-badge>
        </div>

        <p-divider></p-divider>

        <div *ngIf="loadingEntries()" class="tracker-modal-empty">
          Ładowanie wpisów dnia...
        </div>

        <div *ngIf="!loadingEntries() && dayEntries().length === 0" class="tracker-modal-empty">
          <i class="pi pi-calendar-times"></i>
          <p>Brak wpisów dla tego dnia.</p>
          <span>Dodaj pierwszy wpis po lewej stronie.</span>
        </div>

        <div *ngIf="!loadingEntries() && dayEntries().length > 0" class="tracker-modal-list">
          <button
            *ngFor="let entry of dayEntries(); trackBy: trackByEntryId"
            type="button"
            class="tracker-modal-entry"
            [class.is-selected]="isSelectedEntry(entry)"
            (click)="selectEntry(entry)"
          >
            <div class="tracker-modal-entry-main">
              <div class="tracker-modal-entry-top">
                <span class="tracker-modal-entry-title">{{ entry.workItemName || 'Bez nazwy' }}</span>
                <span class="tracker-modal-entry-revenue">
                  {{ formatMoney(resolveEntryEarnings(entry)) }}
                </span>
              </div>
              <span class="tracker-modal-entry-client">{{ entry.clientName || 'Bez klienta' }}</span>
            </div>

            <div class="tracker-modal-entry-meta">
              <span>{{ formatTimeRange(entry.start, entry.end) }}</span>
              <span>{{ formatDuration(entry.duration) }}</span>
              <span>Wynagrodzenie</span>
            </div>

            <p class="tracker-modal-entry-desc">{{ entry.description || 'Brak opisu' }}</p>

            <div class="tracker-modal-entry-footer">
              <span>
                {{ entry.createdByUserName || 'Nieznany autor' }}
                <ng-container *ngIf="entry.createdDate"> · {{ entry.createdDate | date: 'dd.MM.yyyy, HH:mm' }}</ng-container>
              </span>
              <p-badge
                *ngIf="entry.editableByCurrentUser === false"
                value="Tylko odczyt"
                severity="secondary"
              ></p-badge>
            </div>
          </button>
        </div>
      </div>
    </section>
  </div>
</app-modal>
